// extracted by mini-css-extract-plugin
export var cdBackgroundCardGrid = "background-cards-module--cd-background-card-grid--5de42";
export var cdBackgroundCardGridCard = "background-cards-module--cd-background-card-grid-card--704be";
export var cdBackgroundCardSection = "background-cards-module--cd-background-card-section--4dfdf";